export default __webpack_public_path__ + "static/media/challenger.e23cc957.png";